import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";

import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  IconButton,
} from "@mui/material";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { SnackbarProvider, enqueueSnackbar } from "notistack";

import {
  getCustomLicenses,
  deleteCustomLicense,
  clearAllCustomLicenseMessages,
} from "../store/actions";

import CustomLicenseAddEditModal from "./CustomLicenseAddEditModal";

import accessToken from "../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";

const CustomLicensesTable = (props) => {
  console.log("CustomLicensesTable props: ", props);
  const { orgCode } = props;
  const [addEditModalOpen, setAddEditModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);
  const [data, setData] = useState(null);

  const [alertDialogOpen, setAlertDialogOpen] = useState(false);
  const [deleteLicenseName, setDeleteLicenseName] = useState(null);

  const [addOnsDialogOpen, setAddOnsDialogOpen] = useState(false);
  const [addOns, setAddOns] = useState(null);
  const [addOnsName, setAddOnsName] = useState(null);

  const token = accessToken();
  const decoded = jwtDecode(token);
  const userRole = decoded["cognito:groups"];

  const openAddEditCustomLicenseModal = (mode, data) => {
    const desiredData = {
      ...data, 
      "Compliance Add Ons": data["Compliance Add Ons"].map(
        (addOn) => ({Name: addOn.Name, Price: addOn.Price, Description: addOn.Description})
      )
    };
    console.log("openAddEditCustomLicenseModal called with mode " , mode);
    setModalMode(mode);
    setAddEditModalOpen(true);
    setData({ ...desiredData, orgCode });
  }

  const handleDeleteAlertCancel = () => {
    setAlertDialogOpen(false);
    setDeleteLicenseName(null);
  }

  const handleDelete = () => {
    setAlertDialogOpen(false);
    console.log("About to delete customLicense");
    props.deleteCustomLicense(orgCode, deleteLicenseName);
    setDeleteLicenseName(null);
  }

  const initiateDelete = (data) => {
    console.log("About to delete customLicense, ", data);
    setDeleteLicenseName(data.Name);
    setAlertDialogOpen(true);
  }

  const handleAddOnsDialogOpen = (data, addOnsName) => {
    console.log("data ", data);
    setAddOnsDialogOpen(true);
    setAddOns(data);
    setAddOnsName(addOnsName);
  }

  const handleAddOnsDialogClose = () => {
    setAddOnsDialogOpen(false);
    setAddOns(null);
    setAddOnsName(null);
  }

  const clearAllMessages = useCallback(() => {
    props.clearAllMessages();
  }, []);

  const getCustomLicenses = useCallback(() => {
    props.getCustomLicenses(orgCode);
  }, [orgCode]);


  //For displaying message for updating custom license information
  let updateCustomLicenseMsg = props.updateCustomLicenseMessage;
  let updateCustomLicenseErr = props.updateCustomLicenseError;
  useEffect(() => {
    console.log("updateCustomLicenseMsg = " + updateCustomLicenseMsg);
    if (updateCustomLicenseMsg || updateCustomLicenseErr) {
      console.log(
        "Inside if, updateCustomLicenseMsg = " + updateCustomLicenseMsg
      );
      clearAllMessages();
      if(updateCustomLicenseMsg) {
        enqueueSnackbar(updateCustomLicenseMsg, {variant: "success"});
        setAddEditModalOpen(false);
        getCustomLicenses(orgCode);
      }
      if(updateCustomLicenseErr) {
        enqueueSnackbar(updateCustomLicenseErr, {variant: "error"});
      }
    }
  }, [
      updateCustomLicenseMsg, 
      updateCustomLicenseErr, 
      orgCode, 
      clearAllMessages, 
      getCustomLicenses
    ]);

    //For displaying message for deleting custom license information
    let deleteCustomLicenseMsg = props.deleteCustomLicenseMessage;
    let deleteCustomLicenseErr = props.deleteCustomLicenseError;
    useEffect(() => {
      console.log("deleteCustomLicenseMsg = " + deleteCustomLicenseMsg);
      if (deleteCustomLicenseMsg || deleteCustomLicenseErr) {
        console.log(
          "Inside if, deleteCustomLicenseMsg = " + deleteCustomLicenseMsg
        );
        if(deleteCustomLicenseMsg) {
          enqueueSnackbar(deleteCustomLicenseMsg, {variant: "success"});
          props.getCustomLicenses(orgCode);
        }
        if(deleteCustomLicenseErr) {
          enqueueSnackbar(deleteCustomLicenseErr, {variant: "error"});
        }
        props.clearAllMessages();
      }
    }, [deleteCustomLicenseMsg, deleteCustomLicenseErr, orgCode, props]);
  

  const columns = [
    { field: "Name", headerName: "Name", width: 150 },
    { field: "Description", headerName: "CloudCatcher Name", width: 200 },
    { field: "Price", headerName: "Price", width: 100 },
    { field: "Number Of Assets", headerName: "Number Of Assets", width: 150 },
    { field: "Scan Frequency", headerName: "Scan Frequency", width: 150 },
    { field: "Security Posture", headerName: "Security Posture", width: 150 },
    { field: "Support Response", headerName: "Support Response", width: 150 },
    {
      field: "Add ons",
      headerName: "Add ons",
      width: 80,
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          onClick={ () => handleAddOnsDialogOpen(params.row["Add ons"], "Add Ons") }
        >
          {params.row["Add ons"].length}
        </IconButton>
      ),
    },
    {
      field: "Compliance Add Ons",
      headerName: "Compliance Add Ons",
      width: 180,
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          onClick={ () => handleAddOnsDialogOpen(params.row["Compliance Add Ons"], "Compliance Add Ons") }
        >
          {params.row["Compliance Add Ons"].length}
        </IconButton>
      ),
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          onClick={ () => openAddEditCustomLicenseModal("edit", params.row) }
        >
          <EditIcon />
        </IconButton>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      width: 100,
      renderCell: (params) => {
        // Check if the user is an admin
        if (userRole.includes("Admin")) {
          return (
            <IconButton
              color="secondary"
              onClick={() => initiateDelete(params.row)}
              disabled={props.isDeletingCustomLicense}
            >
              <DeleteIcon />
            </IconButton>
          );
        } else {
          return (
            <IconButton color="secondary" disabled className="Mui-disabled">
              <DeleteIcon />
            </IconButton>
          );
        }
      },
    },
  ];

  const addOnsColumns = [
    { field: "Name", headerName: "Name", width: 150 },
    { field: "Price", headerName: "Price", width: 80 },
    { field: "Description", headerName: "Description", width: 220 },
  ];

  return (
    <div>
      <SnackbarProvider />
      <h3>Custom Licenses</h3>
      {props.customLicenses && (
        <DataGrid
          rows={props.customLicenses}
          // rows={organizations}
          columns={columns}
          pageSize={5}
          components={{
            Toolbar: GridToolbar,
          }}
          disableSelectionOnClick
          autoHeight
          disableColumnMenu
          disableColumnSelector
          getRowId={(row) => row.Name}
          density="compact"
        />
      )}
      { addEditModalOpen && modalMode === "edit" && (
        <CustomLicenseAddEditModal 
          mode={modalMode}
          isOpen={addEditModalOpen}
          setOpen={setAddEditModalOpen}
          license={data}
        />
      )}
      { alertDialogOpen && (
        <Dialog
        open={alertDialogOpen}
        onClose={handleDeleteAlertCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm delete custom license?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You have clicked to delete a custom license <strong>{deleteLicenseName}</strong>. 
            <br/>
            Are you really sure you want to delete?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={handleDelete} >Delete</Button>
          <Button variant="contained" onClick={handleDeleteAlertCancel} autoFocus>Cancel</Button>
        </DialogActions>
      </Dialog>
      )}

      { addOnsDialogOpen && (
        <Dialog
        open={addOnsDialogOpen}
        onClose={handleAddOnsDialogClose}
        aria-labelledby="addons-dialog-title"
        aria-describedby="addons-dialog-description"
      >
        <DialogTitle id="addons-dialog-title">
          {addOnsName}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="addons-dialog-description"> */}
            <div style={{ height: 350, width: '100%' }}>
              <DataGrid
                rows={addOns}
                columns={addOnsColumns}
                pageSize={5}
                // autoHeight
                disableSelectionOnClick
                disableColumnMenu
                disableColumnSelector
                getRowId={(row) => row.Name}
                density="compact"
              />
            </div>
          {/* </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleAddOnsDialogClose} autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    isGettingCustomLicense,
    getCustomLicensesError,
    getCustomLicensesMessage,
    
    isUpdatingCustomLicense,
    updateCustomLicenseError,
    updateCustomLicenseMessage,

    isDeletingCustomLicense,
    deleteCustomLicenseError,
    deleteCustomLicenseMessage,
  
  } = state.customLicense;
  return {
    isGettingCustomLicense,
    getCustomLicensesError,
    getCustomLicensesMessage,

    isUpdatingCustomLicense,
    updateCustomLicenseError,
    updateCustomLicenseMessage,

    isDeletingCustomLicense,
    deleteCustomLicenseError,
    deleteCustomLicenseMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomLicenses: (orgCode) => {
      dispatch(getCustomLicenses(orgCode));
    },
    deleteCustomLicense: (orgCode, licenseName) => {
      dispatch(deleteCustomLicense(orgCode, licenseName));
    },
    clearAllMessages: () => {
      dispatch(clearAllCustomLicenseMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomLicensesTable);